/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentPresenceEvent,
  AgentPresenceEvent$inboundSchema,
} from "./agentpresenceevent.js";

/**
 * Websocket event type
 */
export const UserActivityEventType = {
  AlarmActivation: "alarm_activation",
  Error: "error",
  Keepalive: "keepalive",
  Reading: "reading",
  Setting: "setting",
  ShutdownBanner: "shutdown_banner",
  Trends: "trends",
  UserActivity: "user_activity",
} as const;
/**
 * Websocket event type
 */
export type UserActivityEventType = OpenEnum<typeof UserActivityEventType>;

/**
 * Record that something happened to a platform resource.
 *
 * @remarks
 * 	Zero or one fields are present: zero for keepalives; for other event types.
 * 	An empty (keepalive) event is sent periodically to prevent load balancers and firewalls from closing the connection due to idleness.
 */
export type UserActivityEvent = {
  /**
   * The trace metadata, initialized by the trace stream interceptor
   */
  traceMetadata?: { [k: string]: string } | undefined;
  /**
   * Event indicating that an agent has gone on- or offline.
   */
  agentPresence?: AgentPresenceEvent | undefined;
  /**
   * Websocket event type
   */
  type: UserActivityEventType;
};

/** @internal */
export const UserActivityEventType$inboundSchema: z.ZodType<
  UserActivityEventType,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(UserActivityEventType);

/** @internal */
export const UserActivityEvent$inboundSchema: z.ZodType<
  UserActivityEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  TraceMetadata: types.optional(z.record(types.string())),
  agent_presence: types.optional(AgentPresenceEvent$inboundSchema),
  type: UserActivityEventType$inboundSchema.default("user_activity"),
}).transform((v) => {
  return remap$(v, {
    "TraceMetadata": "traceMetadata",
    "agent_presence": "agentPresence",
  });
});

export function userActivityEventFromJSON(
  jsonString: string,
): SafeParseResult<UserActivityEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserActivityEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserActivityEvent' from JSON`,
  );
}
